import React, { useState } from 'react';
import {
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Box,
  Typography,
} from '@mui/material';
import {
  Person as PersonIcon,
  ShoppingBag as ShoppingBagIcon,
  LocationOn as LocationIcon,
  Logout as LogoutIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutCustomer } from '../../../redux/slices/ecommerceCustomerSlice';

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { profile, isAuthenticated } = useSelector((state) => state.ecommerceCustomer);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleClose();
  };

  const handleLogout = async () => {
    await dispatch(logoutCustomer());
    handleClose();
    navigate('/shop');
  };

  if (!isAuthenticated) {
    return (
      <Button
        color="inherit"
        onClick={() => navigate('/shop/login')}
        startIcon={<PersonIcon />}
      >
        Login
      </Button>
    );
  }

  const getInitials = () => {
    if (!profile) return '?';
    const firstInitial = profile.first_name?.charAt(0) || '';
    const lastInitial = profile.last_name?.charAt(0) || '';
    return `${firstInitial}${lastInitial}`.toUpperCase() || 'U';
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="inherit"
        aria-label="User menu"
        aria-controls="user-menu"
        aria-haspopup="true"
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
          {getInitials()}
        </Avatar>
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1.5,
            minWidth: 220,
          },
        }}
      >
        {/* User Info Header */}
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {profile?.first_name} {profile?.last_name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {profile?.email}
          </Typography>
        </Box>
        <Divider />

        {/* Menu Items */}
        <MenuItem onClick={() => handleNavigate('/shop/my-account')}>
          <ListItemIcon>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Account</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleNavigate('/shop/my-orders')}>
          <ListItemIcon>
            <ShoppingBagIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Orders</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleNavigate('/shop/my-addresses')}>
          <ListItemIcon>
            <LocationIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Addresses</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
